// src/guards/is-element/is-element.ts
var isElement = (value) => value instanceof Element;

export {
  isElement
};
